"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const CloseButton_1 = __importDefault(require("./shared/CloseButton"));
const notifications = __importStar(require("../notifications"));
const Backdrop_1 = __importDefault(require("@material-ui/core/Backdrop"));
const viewMode_1 = require("../domain/model/viewMode");
exports.default = react_1.default.memo(NotificationBar);
const useStyles = makeStyles_1.default((theme) => ({
    topBar: {
        display: "flex",
        height: 32,
        padding: 4,
        textAlign: "center",
        alignItems: "center",
        backgroundColor: "#dea941",
        color: "white",
        "& button": {
            background: "none!important",
            textDecoration: "underline",
            backgroundColor: "inherit",
            color: "inherit",
        }
    },
    message: {
        flex: "1 0 auto",
        [theme.breakpoints.down('sm')]: {
            fontSize: "14px"
        },
    },
    cancelButton: {
        width: 0,
        height: 0,
    },
}));
function NotificationBar(props) {
    const classes = useStyles();
    const myUserId = react_redux_1.useSelector((state) => { var _a; return (_a = state.usersState.me) === null || _a === void 0 ? void 0 : _a.userId; });
    const [showBar, setShowBar] = react_1.useState(false);
    const [showBackdrop, setShowBackdrop] = react_1.useState(false);
    const viewMode = react_redux_1.useSelector((state) => state.appState.viewMode);
    react_1.useEffect(() => {
        (() => __awaiter(this, void 0, void 0, function* () {
            let status = yield notifications.status();
            if (status === notifications.Status.Prompt) {
                renderBar(true);
            }
            else if (status === notifications.Status.Granted) {
                notifications.trySubscribe(myUserId);
            }
        }))();
    }, []);
    function renderBar(render) {
        setShowBar(render);
        props.onRender(render);
    }
    function onEnable() {
        return __awaiter(this, void 0, void 0, function* () {
            setShowBackdrop(true);
            try {
                let permission = yield notifications.askForPermission();
                renderBar(false);
                if (permission === "granted") {
                    notifications.trySubscribe(myUserId);
                }
            }
            finally {
                setShowBackdrop(false);
            }
        });
    }
    const message = viewMode === viewMode_1.ViewMode.Mobile ? "Give permission to " : "OpenChat needs your permission to ";
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Backdrop_1.default, { open: showBackdrop, sx: { color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 } }),
        showBar ?
            react_1.default.createElement("div", { className: classes.topBar },
                react_1.default.createElement("div", { className: classes.message },
                    message,
                    react_1.default.createElement("button", { onClick: onEnable }, "enable notifications")),
                react_1.default.createElement(CloseButton_1.default, { onClick: () => setShowBar(false), className: classes.cancelButton })) : null));
}
